// /opt/isp_erp/frontend/src/components/warehouse/SucursalesResumenPanel.jsx
import React, { useState, useEffect } from "react";
import { Box, Card, CardContent, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, Chip } from "@mui/material";
import axios from "../../api/axios";

/** Una fila por sucursal con sus equipos y viñetas. Solo aparece si hay sucursales. */
export default function SucursalesResumenPanel() {
  const [filas, setFilas] = useState([]);

  useEffect(() => {
    axios.get("/warehouse/sucursales-equipos/dashboard")
      .then((r) => setFilas(r.data.sucursales || []))
      .catch(() => setFilas([]));
  }, []);

  if (filas.length === 0) return null;
  return (
    <Box sx={{ p: 3, pb: 0 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Equipos en las sucursales</Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                  <TableCell>Sucursal</TableCell>
                  <TableCell align="right">Equipos (total)</TableCell>
                  <TableCell align="right">En la sucursal</TableCell>
                  <TableCell align="right">Disponibles</TableCell>
                  <TableCell align="right">En revisión</TableCell>
                  <TableCell align="right">Con técnicos</TableCell>
                  <TableCell align="right">En camino</TableCell>
                  <TableCell align="right">En RMA</TableCell>
                  <TableCell align="right">Viñetas</TableCell>
                  <TableCell align="right">Técnicos</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filas.map((f) => (
                  <TableRow key={f.id} hover>
                    <TableCell><strong>{f.nombre}</strong></TableCell>
                    <TableCell align="right"><strong>{f.equipos_total}</strong></TableCell>
                    <TableCell align="right">{f.en_inventario}</TableCell>
                    <TableCell align="right">{f.disponibles}</TableCell>
                    <TableCell align="right">{f.en_revision > 0 ? <Chip size="small" color="warning" label={f.en_revision} /> : "—"}</TableCell>
                    <TableCell align="right">{f.con_tecnicos}{f.retiro_pendiente > 0 ? ` (${f.retiro_pendiente} por devolver)` : ""}</TableCell>
                    <TableCell align="right">{f.en_camino}</TableCell>
                    <TableCell align="right">{f.en_rma}</TableCell>
                    <TableCell align="right">{f.vinetas_total}</TableCell>
                    <TableCell align="right">{f.tecnicos}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}
